import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const GET = "get";
const EDIT = "update";
const CREATE = "create";
const Apilimit = "Apilimit";
const GET_BUSINESS_SUITES = process.env.VUE_APP_BRAINED_API_URL;
const SUITES = "Get";
export default {
  getBrandProfile(payload) {
    return Repository.post(transformRoute(GET), payload);
  },
  uploadBrandProfile(payload) {
    return Repository.post(transformRoute(EDIT), payload);
  },
  createBrandProfile(payload) {
    return Repository.post(transformRoute(CREATE), payload);
  },
  getBusinessSuites(payload) {
    return Repository.post(`${GET_BUSINESS_SUITES}brained/suites/view_suites`);
  },
  getSuites(payload) {
    return Repository.post(transformRoute2(SUITES), payload);
  },
  Ailimit(payload) {
    return Repository.post(transformRoute(Apilimit), payload);
  },
};

const transformRoute = (route) => {
  return `/miniStore/brandProfile/${route}`;
};
const transformRoute2 = (route) => {
  return `/masters/suite/${route}`;
};
